import type { PayPeriodRecord } from '@libs/data-access/entities'

import { getDataByForeignId } from '../../services/immutableUtils'

export const getPrincipalPayPeriodsForAccount = (state, accountId) =>
  getDataByForeignId(state, 'payPeriods', 'account_id', accountId).filter(
    ({ principal }) => principal
  )

export const getPrincipalLockedPayPeriodsForAccount = (state, accountId) =>
  getDataByForeignId(state, 'payPeriods', 'account_id', accountId).filter(
    ({ principal, locked_at }) => principal && locked_at
  )

export const getPayPeriodById = (state, payPeriodId) =>
  state.payPeriods.getIn(['data', Number(payPeriodId)])

export const getPayPeriodByIdFactory =
  (state): ((payPeriodId: number) => PayPeriodRecord) =>
  (payPeriodId: number): PayPeriodRecord =>
    getPayPeriodById(state, payPeriodId)
